<script setup lang="ts">
import { computed, ref } from 'vue'

const STUDENT_LOGIN_PATH = '/users/login_as_student'

type Student = {
  id: number
  first_name: string
  last_name: string
  login_token: string
}

const props = withDefaults(
  defineProps<{
    students?: Student[]
    modelValue?: boolean
  }>(),
  {
    students: () => []
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const selectedStudentId = ref(-1)

const studentsList = computed(() => {
  return props.students.map(student => ({
    text: `${student.last_name} ${student.first_name}`,
    value: student.id
  }))
})

function loginAsStudent() {
  if (selectedStudentId.value < 0) return

  const student = props.students.find(item => item.id === selectedStudentId.value)
  if (!student) return

  const url = new URL(STUDENT_LOGIN_PATH, window.location.href)
  url.searchParams.set('student_id', String(student.id))
  url.searchParams.set('token', student.login_token)
  window.location.href = url.toString()
}
</script>

<template>
  <v-rich-modal title="Войти как ребенок" :model-value="props.modelValue" persistent>
    <div class="login-students-modal">
      <p class="my-2">Выберите ученика из списка:</p>
      <div class="flex-spacer scrollable">
        <v-radio-group v-model="selectedStudentId" :items="studentsList"></v-radio-group>
      </div>

      <div class="my-3 flex-adaptive">
        <v-button mode="outlined block" @click="emit('update:modelValue', false)"> Назад </v-button>
        <div class="ma-1"></div>
        <v-button mode="primary filled block" :disabled="selectedStudentId === -1" @click="loginAsStudent">
          Выбрать
        </v-button>
      </div>

      <p class="text-caption text-center">
        После входа на сайт функционал будет ограничен в рамках выбранного кабинета ребёнка
      </p>
    </div>
  </v-rich-modal>
</template>

<style lang="scss">
.login-students-modal {
  @include desktop {
    width: 320px;
  }
}
</style>
